// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"TableColumnToggler_dropdown__1VSN2"};